// i18n.js — языки интерфейса: русский, казахский, английский, китайский
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru';
import kk from './locales/kk';
import en from './locales/en';
import zh from './locales/zh';
import dictEn from './locales/dict_en';
import dictKk from './locales/dict_kk';
import dictZh from './locales/dict_zh';

export const LANGUAGES = [
  { code: 'ru', label: 'Русский' },
  { code: 'kk', label: 'Қазақша' },
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' },
];

const KEY = 'lang';
const CODES = LANGUAGES.map(l => l.code);

function storedLanguage() {
  try {
    const v = localStorage.getItem(KEY);
    if (v && CODES.includes(v)) return v;
  } catch (e) { /* localStorage недоступен */ }
  return 'ru'; // по умолчанию русский; язык браузера не применяем, чтобы не удивлять клиентов
}

export function setLanguage(code) {
  if (!CODES.includes(code)) return;
  try { localStorage.setItem(KEY, code); } catch (e) { /* ignore */ }
  i18n.changeLanguage(code);
}

i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    kk: { translation: kk },
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: storedLanguage(),
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
});

const syncHtmlLang = (lng) => { try { document.documentElement.lang = lng; } catch (e) { /* ignore */ } };
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

// tt('Русский текст') — перевод строки по её русскому тексту (для ru возвращает текст как есть).
// Можно использовать где угодно (в том числе вне компонентов); {{name}} подставляется из vars.
const DICTS = { en: dictEn, kk: dictKk, zh: dictZh };
export function tt(text, vars) {
  const lang = (i18n.language || 'ru').slice(0, 2);
  const d = DICTS[lang];
  let s = (d && d[text]) || text;
  if (vars) s = s.replace(/\{\{(\w+)\}\}/g, (m, k) => (vars[k] === undefined || vars[k] === null ? '' : String(vars[k])));
  return s;
}

export default i18n;
